import styled from 'styled-components';

export const ModalContent = styled.div`
  position: relative;
  padding: 0px;
  max-width: 520px;
  width: 100%;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0px;
  right: 0px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text || '#333'};
  line-height: 1;
  padding: 4px;

  &:hover {
    opacity: 0.7;
  }
`;

export const StepIndicator = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
`;

export const StepDot = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  background: ${({ active, completed, theme }) =>
    (active || completed) ? (theme.colors.primary || '#2e7d32') : 'transparent'};
  color: ${({ active, completed, theme }) =>
    (active || completed) ? '#fff' : (theme.colors.textLight || '#999')};
  border: 2px solid ${({ active, completed, theme }) =>
    (active || completed) ? (theme.colors.primary || '#2e7d32') : (theme.colors.border || '#ccc')};
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  svg {
    width: 48px;
    height: 48px;
    stroke: ${({ theme }) => theme.colors.primary || '#2e7d32'};
  }
`;

export const Heading = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 12px 0;
  color: ${({ theme }) => theme.colors.textDark || '#000'};
`;

export const Paragraph = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 16px 0;
  color: ${({ theme }) => theme.colors.textLight || '#555'};

  strong {
    color: ${({ theme }) => theme.colors.textDark || '#000'};
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 24px;

  button {
    width: 100%;
  }
`;

export const DetailsTable = styled.div`
  margin: 16px 0;
  border: 1px solid ${({ theme }) => theme.colors.border || '#e0e0e0'};
  border-radius: 6px;
  padding: 15px;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textLight || '#666'};
`;

export const DetailValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text || '#333'};
  text-align: right;
`;

export const PrivacyBox = styled.div`
  margin: 16px 0;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border || '#e0e0e0'};
  border-radius: 6px;
  max-height: 160px;
  overflow-y: auto;
`;

export const PrivacyHeading = styled.h4`
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: ${({ theme }) => theme.colors.text || '#333'};
`;

export const PrivacyText = styled.p`
  font-size: 12px;
  line-height: 1.6;
  margin: 0;
  color: ${({ theme }) => theme.colors.textLight || '#555'};
`;

export const ConsentText = styled.p`
  font-size: 12px;
  line-height: 1.5;
  margin: 12px 0 0 0;
  color: ${({ theme }) => theme.colors.textLight || '#555'};
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;

  button {
    flex: 1;
  }
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 16px 0 0 0;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text || '#333'};

  input[type='checkbox'] {
    margin-top: 3px;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    accent-color: ${({ theme }) => theme.colors.primary || '#2e7d32'};
  }
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 0;
`;

export const SuccessIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  animation: popIn 0.4s ease-out 0s 1 normal forwards;

  @keyframes popIn {
    0% { transform: scale(0); opacity: 0; }
    80% { transform: scale(1.1); }
    100% { transform: scale(1); opacity: 1; }
  }

  svg {
    width: 64px;
    height: 64px;
    stroke: ${({ theme }) => theme.colors.primary || '#2e7d32'};
  }
`;

export const SuccessTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 12px 0;
  color: ${({ theme }) => theme.colors.text || '#333'};
`;

export const SuccessDescription = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 24px 0;
  color: ${({ theme }) => theme.colors.textLight || '#555'};
`;
